import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../hooks/use-toast';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();
    
    // Mock registration
    const mockUsers = JSON.parse(localStorage.getItem('mockUsers') || '[]');
    
    // Check if user already exists
    if (mockUsers.find(u => u.email === email)) {
      toast({
        title: 'Hata!',
        description: 'Bu email zaten kayıtlı.',
        variant: 'destructive',
      });
      return;
    }
    
    const newUser = {
      id: Date.now(),
      name,
      email,
      password,
      role: 'customer'
    };
    
    mockUsers.push(newUser);
    localStorage.setItem('mockUsers', JSON.stringify(mockUsers));
    localStorage.setItem('user', JSON.stringify(newUser));
    
    toast({
      title: 'Başarılı!',
      description: 'Kayıt başarılı. Yönlendiriliyorsunuz...',
    });
    
    setTimeout(() => {
      navigate('/dashboard');
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-900/20 via-transparent to-transparent"></div>
      
      <div className="relative z-10 w-full max-w-md">
        <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-2xl p-8 shadow-2xl shadow-green-500/10">
          <div className="text-center mb-8">
            <Link to="/" className="inline-flex items-center space-x-2 mb-4">
              <img src="/logo.webp" alt="Swenzy" className="w-12 h-12 rounded-lg" />
              <span className="text-2xl font-bold text-green-400">Swenzy</span>
            </Link>
            <h1 className="text-3xl font-bold text-white mt-4">Kayıt Ol</h1>
            <p className="text-gray-400 mt-2">Yeni hesap oluşturun</p>
          </div>

          <form onSubmit={handleRegister} className="space-y-6">
            <div>
              <Label htmlFor="name" className="text-white">Ad Soyad</Label>
              <Input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-2 bg-gray-800 border-green-500/30 text-white focus:border-green-500"
                placeholder="Adınız Soyadınız"
                required
              />
            </div>

            <div>
              <Label htmlFor="email" className="text-white">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-gray-800 border-green-500/30 text-white focus:border-green-500"
                placeholder="ornek@email.com"
                required
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-white">Şifre</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-gray-800 border-green-500/30 text-white focus:border-green-500"
                placeholder="••••••••"
                required
                minLength={6}
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-black font-semibold py-3"
            >
              Kayıt Ol
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-400">
              Zaten hesabınız var mı?{' '}
              <Link to="/login" className="text-green-400 hover:text-green-300 font-semibold">
                Giriş Yap
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;